import type React from 'react';
import { useCallback } from 'react';

import { PlaybookCard } from '../../playbook-card/playbook-card';

import { usePlaybooks } from '../use-playbooks';
import { useOpenRuleEditor } from '../use-open-rule-editor';
import { messages } from '../messages';

export const State48RuleCard: React.FC = () => {
  const openRuleEditor = useOpenRuleEditor();
  const { state48Rule } = usePlaybooks();
  const handleClick = useCallback(() => openRuleEditor(state48Rule), [openRuleEditor, state48Rule]);

  return (
    <PlaybookCard
      description={messages.state48ShippingDescription}
      glyph='locationPin'
      onClick={handleClick}
      title={messages.state48ShippingTitle}
    />
  );
};
